import { Connection } from '../../connections/connection.class';
import { moveSourceIslandCfn } from '../../connections/functions';
import { Obstruction } from '../obstruction.class';

export const setSizeStandardPanelsCfn = (obstruction: Obstruction): void => {
	if (!obstruction.initialized) return;

	try {
		if (obstruction.connections.children.length > 0) {
			const connections = !obstruction.connections.children[0].isSource
				? obstruction.connections.children
				: obstruction.connections.getSourceConnections();
			connections.forEach((c) => moveSourceIslandCfn(c as Connection));
		}
	} catch (error) {
		console.error(`setSizeStandardPanelsCfn:Error repositioning connections for obstruction ${obstruction.id}:`, error);
	}
}
